import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import {
  IPositionDetail,
  IPositionPageRequest,
  IPositionSaveRequest,
  IPositionSaveResponse,
  IPositionByIndustryRequest,
  IPositionConfigDetail,
  IDeletePositionConfigRequest,
  IDeletePositionConfigResponse,
} from '../../../../types/system/base/job';

const hostUrl = getHostbaseUrl();

/**
 * 查询职位配置分页列表
 * @param params 查询参数
 * @returns 分页数据
 */
export async function queryPositionPage(params: IPositionPageRequest) {
  try {
    let data = [] as IPositionDetail[];
    let total = 0;
    const { code, context, message } = await Http.post<{ data: IPositionDetail[]; total: number }>(
      `${hostUrl}/side/sys/position-config/page`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IPositionDetail[]; total: number };

      data = items || [];
      total = all || 0;
      return {
        data,
        total,
      };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 新增或修改职位配置
 * @param params 保存参数
 */
export async function savePosition(params: IPositionSaveRequest): Promise<boolean> {
  try {
    const { code, message } = await Http.post<IPositionSaveResponse>(
      `${hostUrl}/side/sys/position-config/add`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return true;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 通过行业查询关联职位
 * @param params 查询参数
 */
export async function queryPositionsByIndustry(params: IPositionByIndustryRequest) {
  let data = [] as IPositionConfigDetail[];

  try {
    const { code, context, message } = await Http.get<IPositionConfigDetail[]>(
      `${hostUrl}/side/sys/position-config/find-position`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      data = context || [];
      return data;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 删除职位配置
 * @param params 删除参数
 */
export async function deletePositionConfig(params: IDeletePositionConfigRequest) {
  try {
    const { code, message } = await Http.get<IDeletePositionConfigResponse>(
      `${hostUrl}/side/sys/position-config/delete`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return { data: true };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 职位集合查询
 * @param industryId 查询参数
 */
export async function queryAllPositionList() {
  let data = [] as IPositionConfigDetail[];

  try {
    const { code, context, message } = await Http.post<IPositionConfigDetail[]>(
      `${hostUrl}/side/sys/position-config/list`,
      { },
    );

    if (code === EAxiosResponseCode.Succeed) {
      return context || data;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 通过行业查询所有关联职位
 * @param industryId 查询参数
 */
export async function queryPositionList(industryId: number) {
  let data = [] as IPositionConfigDetail[];

  try {
    const { code, context, message } = await Http.get<IPositionConfigDetail[]>(
      `${hostUrl}/side/sys/position-config/find-position`,
      { industryId },
    );

    if (code === EAxiosResponseCode.Succeed) {
      return context || data;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 批量配置职位
 */
export async function setTradePostions(tradeId: number, positions: number[]) {
  let data = {};

  try {
    const { code, context, message } = await Http.post<{}>(
      `${hostUrl}/side/sys/trade/config/position`,
      {
        tradeId,
        positions, 
      },
    );

    if (code === EAxiosResponseCode.Succeed) {
      return context || data;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

